class Menu {
    mobileMenu;
    burgerButton;
    open;
    constructor(mobileMenu, mobileMenuButton) {
        this.mobileMenu = mobileMenu;
        this.burgerButton = mobileMenuButton;
        this.open = false;
    }
    setListeners() {
        let that = this;
        this.burgerButton.on("click", function () {
            that.onButtonClick();
        });
    }
    onButtonClick() {
        if (this.open) {
            this.closeMobileMenu();
        }
        else {
            this.openMobileMenu();
        }
    }
    openMobileMenu() {
        $(this.mobileMenu).addClass('active');
        $(this.burgerButton).addClass('active');
        this.open = true;
    }
    closeMobileMenu() {
        $(this.mobileMenu).removeClass('active');
        $(this.burgerButton).removeClass('active');
        this.open = false;
    }
}
export default Menu;
